import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";

import { ElementSize } from "./resize-observer.model";
import { ResizeObserverService } from "./resize-observer.service";

/**
 * Angular directive to enable observation of size changes in a host element.
 *
 * Usage:
 * @example
 * <element obgResizeObserver (resize)="myResizeFunction($event)"> ... </element>
 *
 * export class MyComponent {
 *     :
 *     myResizeFunction(elementSize: ElementSize) {
 *         const { width, height } = elementSize;
 *         console.log(`Element size changed to ${width}px × ${height}px`);
 *     }
 *     :
 * }
 */
@Directive({
	selector: "[obgResizeObserver]",
})
export class ResizeObserverDirective implements OnInit, OnDestroy {
	@Output() resize = new EventEmitter<ElementSize>();

	constructor(
		private elementRef: ElementRef,
		private resizeObserverService: ResizeObserverService
	) {}

	ngOnInit() {
		const element = this.elementRef.nativeElement;
		this.resizeObserverService.registerElement(element, this.resize);
	}

	ngOnDestroy() {
		const element = this.elementRef.nativeElement;
		this.resizeObserverService.unregisterElement(element);
	}
}
